import FJConfig from '@src/config/FJConfig.js';
import FJUtil from './FJUtil.js';

function writeString(view, offset, string) {
    for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
    }
}

function floatTo16BitPCM(output, offset, input) {
    for (var i = 0; i < input.length; i++, offset += 2) {
        var s = Math.max(-1, Math.min(1, input[i]));
        output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
    }
}

const FJAudioUtil = {
    encodeWAV: function (samples, channels = 2) {
        let sampleRate = FJUtil.getAudioSampleRate();
        let numChannels = channels;
        let bitDepth = 16;
        var bytesPerSample = bitDepth / 8;
        var blockAlign = numChannels * bytesPerSample;
        var buffer = new ArrayBuffer(44 + samples.length * bytesPerSample);
        var view = new DataView(buffer);

        /* RIFF identifier */
        writeString(view, 0, 'RIFF');
        /* RIFF chunk length */
        view.setUint32(4, 36 + samples.length * bytesPerSample, true);
        /* RIFF type */
        writeString(view, 8, 'WAVE');
        /* format chunk identifier */
        writeString(view, 12, 'fmt ');
        /* format chunk length */
        view.setUint32(16, 16, true);
        /* sample format (raw) */
        view.setUint16(20, 1, true);
        /* channel count */
        view.setUint16(22, numChannels, true);
        /* sample rate */
        view.setUint32(24, sampleRate, true);
        /* byte rate (sample rate * block align) */
        view.setUint32(28, sampleRate * blockAlign, true);
        /* block align (channel count * bytes per sample) */
        view.setUint16(32, blockAlign, true);
        /* bits per sample */
        view.setUint16(34, bitDepth, true);
        /* data chunk identifier */
        writeString(view, 36, 'data');
        /* data chunk length */
        view.setUint32(40, samples.length * bytesPerSample, true);

        floatTo16BitPCM(view, 44, samples);

        return buffer;
    },
    encodeMp3: function (audioData, channels = 2) {
        return new Promise(res => {
            const taskType = 'encodeAudioDataToMp3';
            const produceAudioWorker = new Worker(FJConfig.PRODUCE_AUDIO_WORKER_PATH);
            produceAudioWorker.postMessage({
                sampleRate: FJUtil.getAudioSampleRate(),
                audioBuffer: audioData.buffer,
                channels,
                taskType,
            });
            produceAudioWorker.onmessage = message => {
                const { data } = message;
                const { result, type } = data;
                if (taskType === type) {
                    res(result);
                } else if (type === 'error') {
                    res();
                }
            };
        });
    },
};

export default FJAudioUtil;
